<template>
    <div class="landingstats">
        <div class="container" v-if="stats != null && weekstats != null">
            <h3 class="text-center display-3 pt-5 mb-0 statstitle">Stats for your server</h3>
            <div class="row py-5">
                <div class="col-12 col-md-12 col-lg-6 col-xl-4">
                    <div class="statsbox">
                        <div class="content">
                            <label class="d-block text-muted mb-1">Open tickets</label>
                            <h2><ICountUp :delay="1000" :endVal="stats.active_tickets" /></h2>
                        </div>
                        <svg
                            viewBox="0 0 24 24"
                            width="48"
                            height="48"
                            stroke="white"
                            stroke-width="1"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        >
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                            <polyline points="14 2 14 8 20 8"></polyline>
                            <line x1="16" y1="13" x2="8" y2="13"></line>
                            <line x1="16" y1="17" x2="8" y2="17"></line>
                            <polyline points="10 9 9 9 8 9"></polyline>
                        </svg>
                    </div>
                </div>
                <div class="col-12 col-md-12 col-lg-6 col-xl-4">
                    <div class="statsbox">
                        <div class="content">
                            <label class="d-block text-muted mb-1">Avg. completion time</label>
                            <h2><ICountUp :delay="1000" :endVal="Number(stats.avg_open_time)" :options="options" /></h2>
                            <small class="d-block text-muted pt-2"
                                ><ICountUp :delay="1000" :endVal="Number(weekstats.avg_open_time)" :options="options" /> in the
                                last 7 days</small
                            >
                        </div>
                        <svg
                            viewBox="0 0 24 24"
                            width="48"
                            height="48"
                            stroke="white"
                            stroke-width="1"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        >
                            <path
                                d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"
                            ></path>
                        </svg>
                    </div>
                </div>
                <div class="col-12 col-md-12 col-lg-6 col-xl-4">
                    <div class="statsbox">
                        <div class="content">
                            <label class="d-block text-muted mb-1">Avg. response time</label>
                            <h2><ICountUp :delay="1000" :endVal="Number(stats.avg_response_time)" :options="options" /></h2>
                            <small class="d-block text-muted pt-2"
                                ><ICountUp :delay="1000" :endVal="Number(weekstats.avg_response_time)" :options="options" /> in
                                the last 7 days</small
                            >
                        </div>
                        <svg
                            viewBox="0 0 24 24"
                            width="48"
                            height="48"
                            stroke="white"
                            stroke-width="1"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        >
                            <circle cx="12" cy="12" r="10"></circle>
                            <polyline points="12 6 12 12 16 14"></polyline>
                        </svg>
                    </div>
                </div>
                <div class="col-12 col-md-12 col-lg-6 col-xl-4">
                    <div class="statsbox">
                        <div class="content">
                            <label class="d-block text-muted mb-1">Total messages</label>
                            <h2><ICountUp :delay="1000" :endVal="stats.total_messages" /></h2>
                            <small class="d-block text-muted pt-2"
                                ><ICountUp :delay="1000" :endVal="weekstats.total_messages" /> in the last 7 days</small
                            >
                        </div>
                        <svg
                            viewBox="0 0 24 24"
                            width="48"
                            height="48"
                            stroke="white"
                            stroke-width="1"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        >
                            <path
                                d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
                            ></path>
                        </svg>
                    </div>
                </div>
                <div class="col-12 col-md-12 col-lg-6 col-xl-4">
                    <div class="statsbox">
                        <div class="content">
                            <label class="d-block text-muted mb-1">Total tickets</label>
                            <h2><ICountUp :delay="1000" :endVal="stats.total_tickets" /></h2>
                            <small class="d-block text-muted pt-2"
                                ><ICountUp :delay="1000" :endVal="weekstats.total_tickets" /> in the last 7 days</small
                            >
                        </div>
                        <svg
                            viewBox="0 0 24 24"
                            width="48"
                            height="48"
                            stroke="white"
                            stroke-width="1"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        >
                            <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                            <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path>
                            <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>
                        </svg>
                    </div>
                </div>
                <div class="col-12 col-md-12 col-lg-6 col-xl-4">
                    <div class="statsbox">
                        <div class="content">
                            <label class="d-block text-muted mb-1">Supporters</label>
                            <h2><ICountUp :delay="1000" :endVal="stats.unqiue_staff" /></h2>
                            <small class="d-block text-muted pt-2"
                                ><ICountUp :delay="1000" :endVal="weekstats.unqiue_staff" /> in the last 7 days</small
                            >
                        </div>
                        <svg
                            viewBox="0 0 24 24"
                            width="48"
                            height="48"
                            stroke="white"
                            stroke-width="1"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        >
                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                            <circle cx="9" cy="7" r="4"></circle>
                            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ICountUp from 'vue-countup-v2'
import { EventBus } from '@/events/eventbus'
import timeConversion from '@/modules/msToReadable.js'
export default {
    name: 'landingstats',
    components: {
        ICountUp,
    },
    data() {
        return {
            options: {
                formattingFn: this.formatDate,
            },
            stats: null,
            weekstats: null,
        }
    },
    created() {
        this.getStats(this.$store.getters.staffGuild)
        EventBus.$on('staffmode', guild => this.getStats(guild))
    },
    destroyed() {
        EventBus.$off('staffmode', guild => this.getStats(guild))
    },
    methods: {
        formatDate(date) {
            return timeConversion(date)
        },
        getStats(guild) {
            let timestamp = Date.now() - 7 * 24 * 60 * 60 * 1000
            this.$stats.getLandingStats(timestamp, guild).then(res => {
                this.weekstats = res
            })
            this.$stats.getLandingStats(null, guild).then(res => {
                this.stats = res
            })
        },
        getTimedStats() {},
    },
}
</script>

<style scoped>
.landingstats .container {
    animation: fadeIn 2s;
}
.statsbox {
    background: #24292d;
    margin: 20px 5px;
    overflow: hidden;
    padding: 20px 20px 20px 30px;
    border-radius: 10px;
    min-height: 124px;
}
.statsbox h2 {
    margin-bottom: 0;
    font-weight: 300;
}
.statsbox .content {
    float: left;
}
.statsbox .content label {
    text-transform: uppercase;
    font-weight: 600;
    letter-spacing: 1px;
    font-size: 14px;
}
.statsbox svg {
    float: right;
}
.statstitle {
    text-transform: uppercase;
}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

@-moz-keyframes fadeIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

@-webkit-keyframes fadeIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

@-o-keyframes fadeIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

@-ms-keyframes fadeIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/landingstats.vue